<template>
  <div id="app">
  	<div class="container">
      <div class="row">
        <div class="col">
          <Header/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <router-view/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Footer/>
        </div>
      </div>
  	</div>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: 'App',
  components: { Header, Footer }
}
</script>


<style lang="scss">
	@import '../node_modules/bootstrap/scss/bootstrap.scss';
  	@import "assets/scss/app.scss"
</style>



// WEBPACK FOOTER //
// src/App.vue